import { useDroppable } from '@dnd-kit/core';
import type { ReactNode } from 'react';

interface TimelineDropZoneProps {
  children: ReactNode;
}

export function TimelineDropZone({ children }: TimelineDropZoneProps) {
  const { setNodeRef } = useDroppable({
    id: 'timeline-drop-zone',
  });

  return (
    <div ref={setNodeRef} className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      {children}
    </div>
  );
}
